import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
  makeStyles,
  Button,
  Typography,
} from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../../hooks/useForm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { fetchCentrosProfesional, fetchEspecialidadesProfesional } from '../../../../../actions/medicos';
import { fetchCentrosMedicosPropios } from '../../../../../actions/centrosMedicosPropios';
import { fetchEspecialidades } from '../../../../../actions/especialidades';
import { useEffect } from 'react';
import { SelectEspecialidades } from '../components/SelectEspecialidades';
import LoadingBeforeViewData from '../../../../compartidos/LoadingBeforeViewData';
import { SelectCentrosMedicos } from '../components/SelectCentrosMedicos';
import { abmMedicosLimpiar, medicosAbmStoreOrUpdate } from '../../../../../actions/medicosabm/medicosAbm';
import { startAlerta } from '../../../../../actions/ui/alertas';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginTop: '30px',
    borderRadius: '5px',
    padding: '20px',
  },
  TypographyRoot: {
    marginBottom: 5,

  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  hideButton: {
    display: "none",
  },
  botonera: {
    padding: 25
  },
  formValidator: {
    padding: 10
  }
}))


export const MedicosModif = (props) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const centrosMedicosPropios = useSelector(state => state.centrosMedicosPropios)
  const especialidades = useSelector(state => state.especialidades)
  const medico = useSelector(state => state.medico)


  useEffect(() => {
    if (medico.consultaMedico?.idEfectorRed > 0) {
      dispatch(fetchEspecialidadesProfesional(medico.consultaMedico?.idEfectorRed))
      dispatch(fetchCentrosProfesional(medico.consultaMedico?.idEfectorRed))
    }
  }, [medico.consultaMedico])

  useEffect(() => {
    dispatch(fetchCentrosMedicosPropios())
    dispatch(fetchEspecialidades())
  }, [])

  const formMedico = {
    cuit: "",
    razonSoci: "",
    nombreEfector: "",
    idTipoEfector: 1,
    idSubTipoEfector: 7,
    telefonoContacto: "",
    mailContacto: "",
    idEstadoEfector: 1,
    fechaBaja: "",
    fechaAlta: "",
    idEfectorRed: "",
    relEfectorPEspecialidad: "",
    efectorPCM: "",
  }

  const [
    formValues,
    handleInputChange,
    reset,
    setearValor
  ] = useForm(medico.consultaMedico ?? formMedico);

  useEffect(() => {
    reset(medico.consultaMedico ?? formMedico)
  }, [medico.consultaMedico])

  const tipoPrestadorSelect = [
    'Profesionales de centros médicos propios',
  ]

  const EspecialidadesOptions = especialidades.items.map(item => ({
    value: item.idEspecialidades,
    label: item.descripcionEspecialidades,
  }));

  const CentrosMedicosOptions = centrosMedicosPropios.items.map(item => ({
    value: item.idCentroMedico,
    label: item.descripcionCentro,
  }))

  if (centrosMedicosPropios.cargada === false || especialidades.cargada === false || medico.profesionalEspecialidades === null || medico.profesionalCentros === null) {
    return <LoadingBeforeViewData />
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (formValues.cuit === "") {
      formValues.cuit = 0
    }
    dispatch(medicosAbmStoreOrUpdate(formValues))
    dispatch(startAlerta("Ha finalizado la carga/modificación del profesional", "success"))
    dispatch(abmMedicosLimpiar());
  }



  return (
    <ValidatorForm className={classes.formValidator} onSubmit={onSubmit}>
      <Grid container spacing={2} style={{ padding: 25 }}>
        <Grid item xs={12} md={6}>
          <FormControl
            disabled={true}
            className={classes.formControl}
            margin="normal"
            fullWidth={true}
          >
            <InputLabel id="demo-simple-select-label">Tipo de Prestador</InputLabel>
            <Select
              autoWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tipoPrestadorSelect}
            >
              {tipoPrestadorSelect.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            disabled={true}
            fullWidth={true}
            id="standard-disabled"
            label="idEfector"
            name="idEfectorRed"
            value={formValues.idEfectorRed}
            autoComplete="off"
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            fullWidth={true}
            disabled={true}
            label="CUIT"
            name="cuit"
            validators={[
              "required",
              "isNumber",
              "maxNumber:99999999999",
              "minNumber:9999999999",
            ]}
            errorMessages={[
              "El CUIT es requerido",
              "Sólo números",
              "Verifique CUIT ingresado",
              "Verifique CUIT ingresado",
            ]}
            value={formValues.cuit}
            onChange={handleInputChange}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            margin="normal"
            fullWidth={true}
            disabled={true}
            label="Razón Social"
            name="razonSoci"
            value={formValues.razonSoci}
            autoComplete="off"
            onChange={(e) => setearValor("razonSoci", e.target.value.toUpperCase())}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            fullWidth={true}
            id="standard-disabled"
            label="Email"
            name="mailContacto"
            value={formValues.mailContacto}
            autoComplete="off"
            onChange={handleInputChange}
            validators={[
              "required",
              "isEmail"
            ]}
            errorMessages={[
              "El Email es requerido",
              "Email invalido"
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            fullWidth={true}
            id="standard-disabled"
            label="Teléfono(sin 0)"
            name="telefonoContacto"
            value={formValues.telefonoContacto || ""}
            onChange={handleInputChange}
            autoComplete="off"
            validators={[
              "required",
              "isNumber",
              "maxNumber:9999999999",
              "minNumber:999999999",
            ]}
            errorMessages={[
              "El teléfono es requerido",
              "Sólo números",
              "Verifique su teléfono",
              "Verifique su teléfono",
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MuiPickersUtilsProvider
            locale={esLocale}
            utils={DateFnsUtils}
          >
            <KeyboardDatePicker
              disableToolbar
              fullWidth={true}
              margin="normal"
              id="fechaAlta"
              label="Fecha Alta"
              variant="inline"
              format="dd/MM/yyyy"
              disabled={true}
              maxDate={moment(new Date()).add(3, 'M')}
              value={
                moment(formValues.fechaAlta).isValid()
                  ? moment(formValues.fechaAlta)
                  : null
              }
              onChange={(date) => {
                setearValor("fechaAlta", date);
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <MuiPickersUtilsProvider
            locale={esLocale}
            utils={DateFnsUtils}
          >
            <KeyboardDatePicker
              disableToolbar
              fullWidth={true}
              margin="normal"
              id="fechaBaja"
              label="Fecha Baja"
              variant="inline"
              format="dd/MM/yyyy"
              disabled={false}
              maxDate={moment(new Date()).add(3, 'M')}
              value={
                moment(formValues.fechaBaja).isValid()
                  ? moment(formValues.fechaBaja)
                  : null
              }
              onChange={(date) => {
                setearValor("fechaBaja", date);
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography className={classes.TypographyRoot} align="center">Centros Médicos</Typography>
          <SelectCentrosMedicos
            CentrosMedicosOptions={CentrosMedicosOptions}
            CentrosMedicosAsignados={medico.profesionalCentros}
            CentrosMedicosItems={centrosMedicosPropios.items}
            IdEfectorRed={medico.consultaMedico?.idEfectorRed}


          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography className={classes.TypographyRoot} align="center">Especialidades</Typography>
          <SelectEspecialidades
            EspecialidadesOptions={EspecialidadesOptions}
            EspecialidadesAsignadas={medico.profesionalEspecialidades}
            EspecialidadesItems={especialidades.items}
            IdEfectorRed={medico.consultaMedico?.idEfectorRed}
          />
        </Grid>
        <Grid container className={classes.botonera} >
          <Grid item sm={8}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<CancelIcon />}
                onClick={props.cerrarModal}
              >
                CANCELAR
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
                type='submit'
                style={{ marginLeft: "0.5rem" }}
              //onClick={props.cerrarModal}
              >
                GUARDAR
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  )
}
